import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PersonAddressService } from '../person-address.service';
import { PersonAddress } from '../person-address';
import { PersonAddressComponent } from '../person-address/person-address.component';
import { PersonService } from '@app/_components/person/person.service';

@Component({
    selector: 'app-person-address-list',
    templateUrl: './person-address-list.component.html',
    styleUrls: ['./person-address-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PersonAddressListComponent implements OnInit {
	constructor(
		private personService: PersonService,
		private personAddressService: PersonAddressService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = personAddressService.statuses;
		this.addressTypes =  this.personService.addressTypes;
	}



	// data
	@Input() personId: any;
	personAddresss: any;
	personAddress: PersonAddress;
	addressTypes: any;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'personAddressId', header: 'Id', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'adrCity', header: 'Address City', width: 'auto' },
		{ field: 'adrState', header: 'Address State', width: 'auto' },
		{ field: 'adrCountry', header: 'Address Country', width: 'auto' },
		/*{ field: 'personId', header: 'PersonId', width: 'auto' },*/
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.personAddressId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-personAddress-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.personId)
			{
				// show only activities that are assigned to this activityProviderId
				let personIdFilter = { 'personId': { 'value': this.personId, 'matchMode': 'in' } };
				Object.assign(event.filters, personIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.personAddressService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.personAddresss = null;
						this.datasource = res.data.addresses;
						this.recordTotal = res.page.recordTotal;
						this.personAddresss = res.data.addresses;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.personAddresss = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(personAddress: PersonAddress) {
		try {
			this.formLoading = true;
			this.personAddressService.update(personAddress)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.personAddresss.map((personAddress, i) => {
							if (personAddress.personAddressId === res.data.personAddress.personAddressId) {
								this.personAddresss[i] = res.data.personAddress;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(personAddress: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(personAddress));

			this.formLoading = true;
			this.personAddressService.delete(personAddress.personAddressId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.personAddresss.splice(this.personAddresss.indexOf(personAddress), 1);
						this.recordTotal = this.personAddresss.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PersonAddress ' + personAddress.personAddressId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PersonAddress ' + personAddress.personAddressId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Address',
			personId: this.personId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonAddressComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPersonAddressCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(personAddress: PersonAddress) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			personAddress: personAddress,
			personId: this.personId,
			title: 'Edit Address'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonAddressComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePersonAddressCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePersonAddressCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPersonAddressCB(personAddress: PersonAddress) {
		console.log('Adding PersonAddress: ' + JSON.stringify(personAddress));
		// if we don't have a personAddresss array yet...
		if (!this.personAddresss) {
			this.personAddresss = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.personAddresss.unshift(personAddress);

		// no idea what this is but it is required to update the array
		this.personAddresss = [...this.personAddresss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonAddress ' + personAddress.personAddressId + ' Added', life: 3000 });
	}

	updatePersonAddressCB(personAddress: PersonAddress) {
		console.log('Updating PersonAddress: ' + JSON.stringify(personAddress));
		let itemIndex = this.personAddresss.findIndex((item: any) => item.personAddressId === personAddress.personAddressId);
		this.personAddresss[itemIndex] = personAddress;

		// no idea what this is but it is required to update the array
		this.personAddresss = [...this.personAddresss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonAddress ' + personAddress.personAddressId + ' Updated', life: 3000 });
	}

	deletePersonAddressCB(personAddress: PersonAddress) {
		console.log('Removing PersonAddress: ' + personAddress);
		this.personAddresss.splice(this.personAddresss.indexOf(personAddress), 1);
		this.recordTotal = this.personAddresss.length;

		// no idea what this is but it is required to update the array
		this.personAddresss = [...this.personAddresss];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonAddress ' + personAddress.personAddressId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.personAddresss ? this.first === (this.personAddresss.length - this.rows) : true; }
	isFirstPage(): boolean { return this.personAddresss ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(personAddress: any) {
		if (personAddress?.status) {
			const status = this.statuses.find((e: any) => e.value == personAddress.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getAddressType(personAddress: any) {
		if (personAddress?.type) {
			const status = this.addressTypes.find((e: any) => e.value == personAddress.type);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
